export function rankFor(score, total, lang) {
  const ratio = total === 0 ? 0 : score / total;
  if (ratio >= 0.9) return lang === 'ar' ? 'أسطورة الشاشة' : 'Screen legend';
  if (ratio >= 0.7) return lang === 'ar' ? 'ناقد محترف' : 'Seasoned critic';
  if (ratio >= 0.5) return lang === 'ar' ? 'متفرج نهم' : 'Avid viewer';
  return lang === 'ar' ? 'تذكرة أولى' : 'First ticket';
}

export const OPTION_MARK = {
  ar: ['أ', 'ب', 'ج', 'د'],
  en: ['A', 'B', 'C', 'D'],
};
